import { Input } from "@chakra-ui/react";
import React from "react";
import ReactInputMask from "react-input-mask";

export const InputMask = React.forwardRef(({ mask, ...props }, ref) => (
  <ReactInputMask
    mask={mask}
    beforeMaskedStateChange={() => console.log("aaa")}
    {...props}
  >
    {(inputProps) => <Input ref={ref} {...inputProps} />}
  </ReactInputMask>
));
